import { withTheme } from 'styled-components'
import PortfolioImage from './PortfolioImage'

export default withTheme(PortfolioImage)
